// @flow
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayNewsCard from 'components/molecules/overlayNewsCard';
import './styles.scss';

export const NewsPublicationOverlay = props => {
  const { data } = props;
  return (
    <div className={'news-overlay-container'}>
      <h1 className={'heading'}>All Publications</h1>
      <Row className={'news-overlay-row'}>
        {data.map((item, idx) => (
          <Col md={4} key={idx} className={'newscard-section'}>
            <OverlayNewsCard data={item} />
          </Col>
        ))}
      </Row>
    </div>
  );
};
